import BaseStyle from '@primevue/core/base/style';

var AnimateOnScrollStyle = BaseStyle.extend({
  name: 'animateonscroll-directive'
});

export { AnimateOnScrollStyle as default };
//# sourceMappingURL=index.mjs.map
